module.exports = __webpack_public_path__ + "static/media/holiday_home.0191677c.png";